import { Link } from 'react-router-dom';
import { useTempEdgeTranslator } from '../../../Hooks/useTranslation';
import { toTestId } from '../../../utils/helpers/toTestId';
import { DEFAULT_MENU_ITEM_ICON } from './menuTabConfig';

const MenuItemLink = ({ item, lang, iconClassName, linkClassName, onClick }) => {
  const { tempedgeTranslator } = useTempEdgeTranslator();
  const ItemIcon = DEFAULT_MENU_ITEM_ICON;

  const testId = `menu-item-${toTestId(item.optionPath)}`;

  return (
    <li>
      <Link className={linkClassName} to={`${item.optionPath}/${lang}`} onClick={onClick} data-testid={testId}>
        <span className={iconClassName}>
          <ItemIcon />
        </span>
        {tempedgeTranslator(item.optionName)}
      </Link>
    </li>
  );
};

export default MenuItemLink;
